export const CPF_NOT_VALID = 'Insira um CPF válido';
export const CPF_WRONG_SIZE = 'Insira o CPF para continuar';

export const LOCAL_STORAGE_CPF = 'ck-cpf';
export const LOCAL_STORAGE_URL_TOKEN = 'ck-uT';
export const LOCAL_STORAGE_UNIT_ID = 'ck-uID';
export const LOCAL_STORAGE_BRAND_ID = 'ck-bID';
export const LOCAL_STORAGE_ALTERNATIVE_MESSAGE = 'ck-aM';
export const LOCAL_STORAGE_STATE_PERSIST = 'ck-data-v2';
